document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('variantModal');
  const imageContainer = modal.querySelector('.modal-images');
  const prevBtn = modal.querySelector('.flickity-prev');
  const nextBtn = modal.querySelector('.flickity-next');
  const closeBtn = modal.querySelector('.modal-close');
  let flickityInstance = null;

  // Custom handlers - stored so we can remove later
  function onPrevClick() {
    if (flickityInstance) flickityInstance.previous();
  }

  function onNextClick() {
    if (flickityInstance) flickityInstance.next();
  }

  // Bind click on each variant image section
  document.querySelectorAll('.variant-image-section').forEach(function (el) {
    el.addEventListener('click', function () {
      const handle = el.getAttribute('data-product-handle');

      // Destroy old Flickity instance if exists
      if (flickityInstance) {
        flickityInstance.destroy();
        flickityInstance = null;
      }

      // Remove old event listeners from custom arrows
      prevBtn.removeEventListener('click', onPrevClick);
      nextBtn.removeEventListener('click', onNextClick);

      imageContainer.innerHTML = '';

      // Fetch product JSON
      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(product => {
          const images = product.images;
          if (!images || images.length === 0) return;

          images.forEach(img => {
            const slide = document.createElement('div');
            slide.className = 'carousel-cell';
            slide.innerHTML = `<img src="${img}" alt="Product Image">`;
            imageContainer.appendChild(slide);
          });

          // Reinitialize Flickity
          flickityInstance = new Flickity(imageContainer, {
            cellAlign: 'center',
            contain: true,
            wrapAround: true,
            pageDots: false,
            imagesLoaded: true,
            prevNextButtons: false
          });

          // Bind custom arrows
          prevBtn.addEventListener('click', onPrevClick);
          nextBtn.addEventListener('click', onNextClick);
        });

      // Show modal
      modal.style.display = 'flex';
      document.body.classList.add('modal-open');
    });
  });

  // Modal click-close logic
  modal.addEventListener('click', function (e) {
    if (!e.target.closest('.modal-content')) {
      closeModal();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  function closeModal() {
    modal.style.display = 'none';
    document.body.classList.remove('modal-open');
    if (flickityInstance) {
      flickityInstance.destroy();
      flickityInstance = null;
    }
    // Unbind to avoid double-binding later
    prevBtn.removeEventListener('click', onPrevClick);
    nextBtn.removeEventListener('click', onNextClick);
    imageContainer.innerHTML = '';
  }
});
